var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldText, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { Field, Form, reduxForm, SubmissionError, } from 'redux-form';
import { analytics } from 'app/utils/segment';
import { withFlows, withWidgets } from 'hocs';
import { useNotifications } from 'hooks/useNotifications';
import { validateName } from 'utils/formValidator';
const FETCH_DELAY = 1600;
const MAX_LENGTH = 255;
const RenameWidgetModalImpl = (props) => {
    const notify = useNotifications();
    const handleFormSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        analytics.chatFormSubmitted({ mode: 'update' });
        const { flows, onClose, refreshPage, widget, widgets } = props;
        try {
            const { name } = values;
            const widgetFlowId = widget.flows[0].id;
            const [{ data: flow }] = yield Promise.all([
                flows.getItem(widgetFlowId),
                widgets.update(widget.id, {
                    updates: {
                        name,
                    },
                }),
            ]);
            yield flows.update(widgetFlowId, Object.assign(Object.assign({}, flow), { name }));
            notify({
                title: 'Widget updated',
                text: `"${name}" widget has been updated`,
                icon: 'done',
                className: 'success',
                time: 5000,
            });
            onClose();
            // fetch widget items with delay to make sure
            // the new list is updated
            setTimeout(() => {
                refreshPage();
            }, FETCH_DELAY);
        }
        catch (_a) {
            notify({
                title: 'An error occurred',
                text: `An error occurred when trying to update the "${widget.name}" widget`,
                icon: 'exclamation',
                className: 'danger',
            });
            throw new SubmissionError({
                name: 'Widget could not be updated',
            });
        }
    });
    const handleCancel = () => {
        analytics.chatFormCanceled({ mode: 'update' });
        props.onClose();
    };
    const { handleSubmit, isOpen, pristine } = props;
    return (_jsx(Modal, Object.assign({ isOpen: isOpen, onClose: handleCancel }, { children: _jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { onClose: handleCancel, title: "Update widget" }), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleFormSubmit) }, { children: [_jsx(ModalBody, { children: _jsx(Field, { label: "Name", name: "name", maxLength: MAX_LENGTH, component: FieldText, type: "text", placeholder: "Widget name", required: true, validate: validateName }) }), _jsx(ModalFoot, { cancelOnClick: handleCancel, confirmName: "Update", confirmOnClick: handleSubmit(handleFormSubmit), confirmProps: {
                                disabled: pristine,
                                type: 'submit',
                            } })] }))] })) })));
};
export const RenameWidgetModal = reduxForm({
    enableReinitialize: true,
    form: 'renameWidgetForm',
    touchOnBlur: false,
})(withWidgets(withFlows(RenameWidgetModalImpl)));
